import { number, shape, string } from 'prop-types';

export const pictureFluidType = shape({
  alt: string,
  width: number.isRequired,
  height: number.isRequired,
  fluid_0: string.isRequired,
});
